import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { withRouter, Link } from "react-router-dom";
import Logo from '../../assets/images/logo-one.svg';

const Footer = (props) => {
  const { t } = useTranslation();
  const {
    location: { pathname }
  } = props;
  if (pathname.includes("profile")) {
    return null;
  }
  return (
    <footer className="footer">
      <div className="d-flex footer-container">
        <div className="footer-links d-flex">
          <img className="footer-logo" src={Logo} alt="footer logo" />
          <Link
            to={{
              pathname: "https://portal.ct.gov/Policies/Disclaimer"
            }}
            target="_blank"
            rel="noreferrer noopener"
            className="footer-links-item"
          >
            {t("common.footer.disclaimer")}
          </Link>
          <Link
            to={{
              pathname: "https://portal.ct.gov/Policies/State-Privacy-Policy"
            }}
            target="_blank"
            rel="noreferrer noopener"
            className="footer-links-item"
          >
            {t("common.footer.privacyPolicy")}
          </Link>
          <Link
            to={{
              pathname:
                "https://www.access.state.ct.us/policies/accesspolicy40.html"
            }}
            target="_blank"
            rel="noreferrer noopener"
            className="footer-links-item"
          >
            {t("common.footer.websiteAccessibility")}
          </Link>
        </div>
        <div className="footer-copyrights mt-3 mt-lg-0 mt-md-0">
          {t("common.footer.copyRightc")}
          {' '}
          {new Date().getFullYear()}
          {' '}
          {t("common.footer.copyRightct")}
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  location: PropTypes.object.isRequired
};
export default withRouter(Footer);
